import ImageModal from './image-modal';

export default ImageModal;
